import { Box, Button } from "@mui/material";
import React from "react";

function NotifcationButton({
  typeHandler,
  category,
  title,
  typeCount,
  isActive,
}) {
  const buttonStyle = {
    color: "#1E6AFD",
    margin: "0 4px",
    position: "reletive",
    minWidth: "80px",
    ":hover": { bgcolor: "#1E6AFD", color: "white" },
  };
  return (
    <Button
      onClick={() => typeHandler(category)}
      sx={{
        ...buttonStyle,
        color: isActive ? "white" : "#1E6AFD",
        bgcolor: isActive ? "#1E6AFD" : "",
      }}
    >
      {title}
      {typeCount != 0 && (
        <Box
          sx={{
            position: "absolute",
            top: "-6px",
            right: "-6px",
            background: "rgb(251, 232, 238)",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "16px",
            height: "16px",
            color: "rgb(212, 22, 79)",
          }}
        >
          <span className="font-num">{typeCount}</span>
        </Box>
      )}
    </Button>
  );
}

export default NotifcationButton;
